import DashboardNav from './components/DashboardNav/index.vue';
import { storageSession } from '@/utils/storage';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Profile',
  components: {
    DashboardNav
  },
  watch: {},
  computed: {
    ...mapGetters({
      user: 'profile/user'
    }),
    isPromoPeriod() {
      let now = new Date();
      let year = now.getFullYear();

      let start = new Date(year, 1, 9);
      let end = new Date(year, 1, 14, 23, 59, 59);

      return now >= start && now <= end;
    }
  },
  methods: {
    ...mapMutations({
      modalOpen: 'app/MODAL_OPEN'
    })
  }
};
